<template>
<span>
    <Modal v-if="showModal" @close="showModal = false">
    <h3 slot="header"> </h3>
        <div slot="body">
            <h2>
            {{ $t('commute.title.start-over') }}
            </h2>
        </div>
        <div slot="footer">
            <button class="modal-default-button green" @click="start_over()">
                ✓ {{ $t('button.OK') }}
              </button>
              &nbsp;
            <button class="modal-default-button  green" @click="showModal = false">
                {{ $t('button.cancel') }}
              </button>
 
        </div>
    </Modal>
  <span>
  <button class="orange big" @click="showModal = true">
        {{ $t('button.start-over') }} <img src="icons/trash_18_white.png">
  </button>
  </span>
</span>
</template>

<script>

import settings from '../settings.js'
import Modal from './Modal.vue'

export default {

    name: 'StartOver',
    components: {
        Modal
    },
    props : {
        commutes : Array
    },
    data : function(){
        return {
            showModal: false
        }
    },
    methods : {
        start_over : function(){
            this.$emit('start_over')
            this.showModal = false
        }    
    }
}
</script>

<style scoped>

#show-modal:hover {
    background-color: #333;
    color: #fff;
}
#show-modal {
    position: fixed;
    top: 0;
    right: 0;
    background-color: #ccc;
    text-align: center;
    padding: 20px 25px;
    cursor: pointer;
}
</style>